import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'; 

@Injectable({
  providedIn: 'root'
})
export class CommitteeService {

  constructor(private http: HttpClient, private httpService: HttpService) {

  }

  addCommittee(newCommittee) {
      var request = {
          URL: "committee/addcommittee",
          DATA: newCommittee
      }
      return this.httpService.post(request);
  }


  getCommitteeList() {
      var request = {
          URL: "committee"
      }
      return this.httpService.get(request);
      // return this.http.get(environment.pssUrl + 'committee')
      //     .map(res => res.json());
  }


  getCommitteeById(committeeId: string) {
      var request = {
          URL: "committee/"+committeeId
      }
      return this.httpService.get(request);
      
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.get(environment.pssUrl + 'committee/' + committeeId)
      //     .map(res => res.json());
  }


  editCommittee(updatedCommittee) {


      var request = {
          URL: "committee/edit/",
          DATA: updatedCommittee
      }
      return this.httpService.post(request);
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // console.log(environment.pssUrl + 'committee/edit/' + updatedCommittee._id, JSON.stringify(updatedCommittee), { headers: headers });
      // return this.http.put(environment.pssUrl + 'committee/edit/', JSON.stringify(updatedCommittee), { headers: headers })
      //     .map(res => res.json());
  }

  deleteCommittee(G_deletingID) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)

      return this.http.get(environment.pssServerUrl + 'committee/delete/' + G_deletingID, { headers: headers })
          .map(res => res);
  }

  // addCommitteeMembers(CommitteeMembers, committeeId) {
  //     var headers = new Headers();
  //     headers.append('Content-Type', 'application/json');
  //     return this.http.post(environment.pssUrl + 'committee/addMembers/' + committeeId, JSON.stringify(CommitteeMembers), { headers: headers })
  //         .map(res => res.json());
  // }

  getCommitteeMembers(committeeID: string) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'committee/getMembers/' + committeeID,{headers:headers})
          .map((res: Response) => res.json());
  }

  addCommitteeDirector(CommitteeDirector, committeeId) {
    const request = {
      URL: 'committee/addDirector/' + committeeId,
      DATA: CommitteeDirector
    };
    return this.httpService.post(request);
  }
  

  getDirectors(committeeID: string, searchParam) {
      var request = {
          URL: "committee/getDirectors/"+ committeeID,
          DATA: searchParam
      }
      return this.httpService.post(request);
  }

  updateCommitteeDirector(CommitteeDirector: any, committeeId: string, dir_id: string) {
    const token = localStorage.getItem('token') || '';
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token
    });
  
    const url = `${environment.pssServerUrl}committee/updateDirector/${committeeId}`;
    const body = JSON.stringify(CommitteeDirector);
  
    console.log('POST to:', url, 'Payload:', CommitteeDirector);
  
    return this.http.post(url, body, { headers });
    // OR if you still need to transform:
    // return this.http.post(url, body, { headers }).pipe(map(res => res));
  }

  addCommitteeInvitee(CommitteeInvitee, committeeId) {
      // committee/addDirector/:committeeId
      var request = {
          URL: "committee/addInvitee/"+committeeId,
          DATA : CommitteeInvitee
      }
      return this.httpService.post(request);
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.post(environment.pssUrl + 'committee/addInvitee/' + committeeId, JSON.stringify(CommitteeInvitee), { headers: headers })
      //     .map(res => res.json());
  }

  addCommitteeMember(CommitteeMember, committeeId) {
       
    var request = {
        URL: "committee/addMember/"+committeeId,
        DATA : CommitteeMember
    }
    return this.httpService.post(request);
}


  updateCommitteeInvitee(CommitteeInvitee, committeeId, invitee_id) {
      // committee/addDirector/:committeeId
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.post(environment.pssServerUrl + 'committee/updateInvitee/' + committeeId, JSON.stringify(CommitteeInvitee), { headers: headers })
      .map((res: Response) => res.json()) 
  }

  updateCommitteeMember(CommitteeMember: any, committeeId: string, member_id: string) {
    const token = localStorage.getItem('token');
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token || ''
    });
  
    return this.http.post(
      `${environment.pssServerUrl}committee/updateMember/${committeeId}`,
      JSON.stringify(CommitteeMember),
      { headers }
    );
  }



  deleteCommitteeDir(type: string, DirInvMem_id: string, committeeId: string) {
    const token = localStorage.getItem('token') || '';
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token
    });
  
    const url = `${environment.pssServerUrl}committeeDelete/${type}/${committeeId}/${DirInvMem_id}`;
  
    return this.http.get<any>(url, { headers }).pipe(
      map(res => res) // you can modify or transform the response here if needed
    );
  }
  
  deleteCommitteeInv( type,DirInvMem_id,committeeId){
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'committeeDelete/'+type+'/'+ committeeId+'/'+DirInvMem_id, { headers: headers })
          .map((res: Response) => res.json());
  }

  deleteCommitteeMem(type: string, DirInvMem_id: string, committeeId: string) {
    const token = localStorage.getItem('token') || '';
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token
    });
  
    const url = `${environment.pssServerUrl}committeeDelete/${type}/${committeeId}/${DirInvMem_id}`;
  
    return this.http.get<any>(url, { headers }).pipe(
      map(res => res) // optional if you're not transforming
    );
  }

  
  getMembersFromGoveva() {
      var request = {
          URL: "user/userListWithoutKMPAndDirector"
          //URL: "userMaster/getInternalUserList"            
      }
      return this.httpService.getGovEvaCall(request);
      // return this.http.get(environment.govevaUrl +"user/userListWithoutKMPAndDirector").map(res => res.json());
      // return this.http.get('http://13.126.228.244:81/api/v1/secure/user/userListWithoutKMPAndDirector')
      // .map(res => res.json());
  }

  getUsersFromGovevaForInvittee() {
      var request = {
          // URL: "user/userListWithoutKMPAndDirector"
          URL: "userMaster/getInternalUserList"            
      }
      return this.httpService.getGovEvaCall(request);
      // return this.http.get(environment.govevaUrl +"user/userListWithoutKMPAndDirector").map(res => res.json());
      // return this.http.get('http://13.126.228.244:81/api/v1/secure/user/userListWithoutKMPAndDirector')
      // .map(res => res.json());
  }


  getInCorpDateOfCompany(){
      var request = {
          URL: "companyMaster/getIncorporationdate/"
      }
      return this.httpService.get(request);
  }

  addCommitteeGovevaMember(CommitteeMember, committeeId) {
      // committee/addDirector/:committeeId
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.post(environment.pssServerUrl + 'committee/addGovEvaMember/'+ committeeId, JSON.stringify(CommitteeMember), { headers: headers })
      .map((res: Response) => res.json()) 
  }

  getActiveDirectorForCommitte(committeeID: string) {
      var request = {
          URL: "committee/getActiveDirectorForCommitte/"+ committeeID
      }
      return this.httpService.get(request);
  }
}